import { useCallback, useContext } from 'react'
import type { TableColumnPreferences } from '@alpha-edge/shared'
import { PreferencesContext } from './use-preferences'

const noop = () => {}

export function useTableColumns(tableId: string) {
  const ctx = useContext(PreferencesContext)

  const prefs = ctx?.getTableColumns(tableId)

  const onChange = useCallback((next: TableColumnPreferences) => ctx?.setTableColumns(tableId, next), [tableId, ctx])

  return {
    tableId,
    columnPrefs: prefs,
    onColumnPrefsChange: ctx ? onChange : (noop as (prefs: TableColumnPreferences) => void),
  }
}
